import { lostPreventionSteps, whyAddressChanges } from "@/mocks/lostPrevention";
import SectionHeading from "./SectionHeading";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="防走失指南"
          title="六步做到不再「找不到入口」"
          desc="所谓防走失，本质是保留一个稳定的回访入口和几条备份地址。按下面六步整理一遍，之后即使某个地址失效，也能很快找回可用的访问方式。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {lostPreventionSteps.map((step, i) => (
            <article
              key={step.id}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center text-xl">
                  <i className={step.icon}></i>
                </span>
                <span className="font-heading text-3xl font-bold text-background-200">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-lg bg-secondary-900 p-6 md:p-8">
          <div className="flex items-center gap-2 mb-5">
            <i className="ri-question-answer-line text-accent-400 text-lg"></i>
            <h3 className="font-heading font-semibold text-lg text-background-50">为什么地址总是会变？</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {whyAddressChanges.map((item) => (
              <div key={item.id} className="border-l-2 border-primary-500 pl-4">
                <h4 className="text-background-50 font-medium text-sm md:text-base">{item.title}</h4>
                <p className="mt-2 text-sm text-secondary-200 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm text-secondary-200 leading-relaxed">
            理解了这三点，就能明白「防走失」的关键并不是记住某一条地址，而是留住一个能持续更新地址的地方 —— 也就是本页。
          </p>
        </div>
      </div>
    </section>
  );
}